/*import React from 'react'
import Helmet from 'react-helmet'

const ProductsServicesEn = () => (
  <div className="page products_services">

  <Helmet
            title={`Productos y servicios de Budget Nicaragua - Encuentra un alquiler de autos cerca de ti`}
            meta={[
              {
                name: 'description',
                content:
                  'Preguntas frecuentes sobre el alquiler de autos.',
              },
            ]}
            link={[
              {
                rel: 'alternate',
                hreflang: 'es',
                href:
                  './en/products-services',
              },
            ]}
          />


    <div className="image"></div>
    <h1>Accesorios y Servicios</h1>  
    <div className="wrapper">
      <div className="block-first">
    
        <ul>
        <li>
           <h3>Mapa Turístico Gratis</h3>
           Con el alquiler de su vehículo, le proporcionamos un mapa turístico de Nicaragua actualizado,
           libre de cualquier costo.
          </li>
          <li>
           <h3>Asistencia Técnica y Legal las 24 horas</h3>
           BUDGET le ofrece protección las 24 horas en cualquier emergencia con su vehículo rentado, 
           en caso de que usted lo solicite al sufrir un accidente, un desperfecto mecánico de su auto 
           rentado o tenga problemas legales. Nuestros números de emergencia de 24 horas son <a href="tel:+50588561509">8856-1509</a> / <a href="tel:+50522789568">(505) 2278 9568</a>
          </li>
          <li>
           <h3>Servicio de Conductores</h3>
           Tenemos a su disposición personal altamente calificado para prestar este servicio con un alto grado 
           de confiabilidad y pericia profesional
          </li>
          <li>
            <h3>Renta de GPS</h3>
            Budget ofrece GPS o mapas electrónicos; los cuales a través de tecnología satelital lo ubican en 
            las principales vías y sitios turísticos de Nicaragua.
          </li>
          <li>
            <h3>Sillas de Seguridad para Niños</h3>
            En BUDGET nos preocupamos por la seguridad de nuestros clientes, especialmente cuando se trata de niños. 
            Por esta razón tenemos disponibles sillas de seguridad para infantes, las que pueden ser rentadas, 
            en todas nuestras sucursales. Este servicio requiere de su solicitud anticipada, para garantizar la efectividad 
            del mismo.
          </li>

        </ul>
      </div>
    </div>
  </div>
)
export default ProductsServicesEn*/



import React, { Component } from 'react'
import Img from 'gatsby-image'
import carImage from '../images/leasing/car.jpg'
import axios from 'axios'
import Helmet from 'react-helmet'
import { backendURL } from '../data/config.json'
import Link from 'gatsby-link'
class ProductsServicesEn extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      descriptionEs: '',
    }

    this.renderTextsProgram = this.renderTextsProgram.bind(this)

  }
  componentDidMount() {
   
      axios
      .get(`${backendURL}/api/texts/sections/TextProgram/Main`)  
      .then(res => {

        const txt = res.data;

        console.log(txt);

        this.setState({     
          descriptionEs:{
            es: txt.descriptionEs,
          }, 
        })
        })

      .catch(err => {
        console.log(err)
      })
  }

  renderTextsProgram() {
    const { texts } = this.state
    return _.map(texts, (text, i) => {
      const { descriptionEs , published } = text
      //const { langKey: lang } = this.props.pathContext
      console.log(text);
      if (published) {
        return (
          <div key={i}>
          <p> 
            {descriptionEs.es} 
          </p>
          </div>
        )
        return null
      }
    })
  } 


  render() {
    return (
      <div className="page corporate_program">
      <Helmet
         title={`Corporate Program |  Budget Guatemala`}
         meta={[
           {
             name: 'description',
             content:
               'Frequently Asked Questions about car rentals.',
           },
         ]}
         link={[
           {
             rel: 'alternate',
             hreflang: 'es',
             href:
               './en/corporate_program',
           },
         ]}
       />
      
  <div className="image"></div>

  <h1>Accesorios y Servicios</h1> 

  <div dangerouslySetInnerHTML={{__html: this.state.descriptionEs.es}}></div>
    
  
</div>
    )
  }
}
export default ProductsServicesEn




// WEBPACK FOOTER //
// ./src/pages/products-services.es.js